/**
 * Barrera de errores: evita que un fallo de render deje la pantalla en blanco
 * (una terminal de apuestas no puede quedar inutilizable).
 */
import { Component, type ErrorInfo, type ReactNode } from 'react';
import { translate } from '../lib/i18n.js';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    // Sin PII: solo el mensaje y el componente.
    console.error('render-error', { message: error.message, componentStack: info.componentStack });
  }

  override render(): ReactNode {
    if (!this.state.error) return this.props.children;
    return (
      <div className="pit-card m-4 p-6" role="alert">
        <h1 className="pit-mono mb-2 text-[var(--pit-text-xl)] uppercase text-[var(--pit-accent-red)]">
          {translate('error.title')}
        </h1>
        <p className="mb-4 text-[var(--pit-text-sm)] text-[var(--pit-text-secondary)]">
          {this.state.error.message}
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="pit-touch rounded-[var(--pit-radius-md)] bg-[var(--pit-accent-cyan)] px-4 py-2 text-[var(--pit-text-sm)] font-[var(--pit-weight-semibold)] uppercase text-[var(--pit-text-inverse)]"
        >
          {translate('app.retry')}
        </button>
      </div>
    );
  }
}
